import { Badge } from "./ui/badge";
import { Button } from "./ui/button";
import { Card, CardContent, CardFooter, CardHeader } from "./ui/card";
import { Calendar, Clock, Edit, Trash2, Tag, Package } from "lucide-react";




export function OfferCard({ offer, onEdit, onDelete }) {
  const discountPercent = offer.DISQ_RATE || 0;
  const isActive = new Date(offer.FDATE) <= new Date() && new Date(offer.TDATE) >= new Date();

  return (
    <Card className="overflow-hidden hover:shadow-lg transition-shadow">
      <CardHeader className="pb-3 bg-gradient-to-r from-primary/5 to-primary/10">
        <div className="flex items-start justify-between gap-2">
          <div className="flex-1 min-w-0">
            <div className="truncate font-semibold text-[17px]">{offer.ITEMNAME}</div>
            <p className="text-muted-foreground mt-1">Code: {offer.ALIAS_CODE}</p>
          </div>
          <div className="flex flex-col items-end gap-2">
            <Badge variant={isActive ? "default" : "secondary"}>
              {isActive ? "Active" : "Scheduled"}
            </Badge>
            <Badge variant="outline">{offer.OFFER_TYPE}</Badge>
          </div>
        </div>
      </CardHeader>

      <CardContent className="pt-4 space-y-3">
        <div className="flex items-center gap-2 text-muted-foreground">
          <Package className="w-4 h-4" />
          <span>{offer.SECTION_NAME}</span>
        </div>

        <div className="flex items-center gap-2 text-muted-foreground">
          <Tag className="w-4 h-4" />
          <span>{offer.PACKING} {offer.UNIT}</span>
        </div>

        <div className="grid grid-cols-2 gap-4 pt-2">
          <div>
            <p className="text-muted-foreground">Original Sale price</p>
            <p className="text-lg">₹{offer.SALE_PRICE}</p>
          </div>
          <div>
            <p className="text-muted-foreground">Offer Sale Price</p>
            <p className="text-lg text-[#0e4919]">₹{offer.OFFER_SALE_PRICE}</p>
          </div>
        </div>

        {discountPercent > 0 && (
  <div className="d-inline-flex align-items-center bg-warning text-dark px-3 py-1 rounded-pill shadow-sm">
    <i className="bi bi-tag-fill me-2"></i>
    <span className="fw-medium">Discount: {discountPercent}%</span>
  </div>
)}


        <div className="pt-2 space-y-2 border-t">
          <div className="flex items-center gap-2 text-muted-foreground">
            <Calendar className="w-4 h-4" />
            <span>
              {new Date(offer.FDATE).toLocaleDateString()} - {new Date(offer.TDATE).toLocaleDateString()}
            </span>
          </div>
          <div className="flex items-center gap-2 text-muted-foreground">
            <Clock className="w-4 h-4" />
            <span>
              {offer.FTIME} - {offer.TTIME}
            </span>
          </div>
        </div>
      </CardContent>

      <CardFooter className="bg-muted/30 gap-2">
        <Button
          variant="outline"
          size="sm"
          className="flex-1"
          onClick={() => onEdit(offer)}
        >
          <Edit className="w-4 h-4 mr-2" />
          Edit
        </Button>
        <Button
          variant="outline"
          size="sm"
          className="flex-1 text-destructive hover:text-destructive"
          onClick={() => onDelete(offer)}
        >
          <Trash2 className="w-4 h-4 mr-2" />
          Delete
        </Button>
      </CardFooter>
    </Card>
  );
}
